import Loading from 'component/Loading';
import Modal from 'component/Modal';
import MicroModal from 'micromodal';
import {Suspense, useEffect, useState} from 'react'
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import Swal from 'sweetalert2';
import { fn_getDayOfWeek } from 'util';
import { api_commonFetch } from 'util';

export default function Home(){
    return (
        <Suspense fallback={<Loading/>}>
            <App/>
        </Suspense>
    );
}

export function App(){
    const navigate = useNavigate();
    const date = new Date();
    const nextDate = new Date(date.getFullYear(), date.getMonth()+1, 0);
    const [params, setParams] = useSearchParams();
    const [vo, setVO] = useState({
        searchStartDate : params.get('searchStartDate') || date.getFullYear() + "-01-01"
        , searchEndDate : params.get('searchEndDate') || date.getFullYear() + "-12-31"
    });
    const [loading, setLoading] = useState(true);

    const [gsMemberList, setGsMemberList] = useState([]);
    const [gsList, setGsList] = useState([]);
    

    const fn_getGsList = async()=>{
        setLoading(true);
        const url = process.env.REACT_APP_API_URL + '/gs?' + new URLSearchParams(vo);
        const config = {method : 'get'}
        const data = await api_commonFetch(url, config);
        setGsList(data.gsList);
        setGsMemberList(data.gsMemberList);
        setLoading(false);
    }

    const fn_search = ()=>{
        const form = document.searchForm;
        const tmp = {
            ...vo
            , searchStartDate : form.searchStartDate.value
            , searchEndDate : form.searchEndDate.value
        }
        setVO(tmp);
        navigate('/gsFellowship?' + new URLSearchParams(tmp));
    }

    const fn_postForm = async()=>{
        let url = "";
        const form = document.postForm;
        const formData = new FormData(form);
        const config = {method : 'post', body : formData}
        let msg = ""

        if(form.no.value == ''){
            url = process.env.REACT_APP_API_URL + '/gsInsertAction'
            msg = '등록하시겠습니까?'
        }else{
            url = process.env.REACT_APP_API_URL + '/gsUpdateAction'
            msg = '수정하시겠습니까?'
        }

        if(form.price.value == '' || form.price.value == 0){
            form.price.focus();
            Swal.fire('금액을 입력하여주시기 바랍니다.');
        }else{
            await Swal.fire({
                title: msg
                , showCancelButton: true
                , confirmButtonText: "확인"
                , cancelButtonText: `취소`
            }).then(async (result) => {
                if (result.isConfirmed) {
                    Swal.fire({
                        title: "처리중입니다.",
                        html: "잠시만 기다려주시기 바랍니다.",
                        allowOutsideClick: false,
                        didOpen: () => {
                            Swal.showLoading();
                        },
                    });
                    
                    const data = await api_commonFetch(url, config);
                    
                    if(data.result>0){
                        await Swal.fire("정상적으로 처리되었습니다.");
                        fn_getGsList();
                        MicroModal.close('modal');
                    }else{
                        await Swal.fire("처리중 오류가 발생하였습니다.");
                    }
                }
            });
        }
    }
    const fn_insert = (ob)=>{        

        let memberNo = 0;

        if(gsList!=null && gsList.length>0){
            let tmp = gsList[0].memberNo;

            if(gsMemberList!=null && gsMemberList.length>0){
                for(let i=0; i<gsMemberList.length; i++){
                    let ob = gsMemberList[i];
                    if(tmp == ob.memberNo){
                        
                        if(i-1 < 0){
                            memberNo = gsMemberList[gsMemberList.length-1].memberNo;
                        }else{
                            memberNo = gsMemberList[i-1].memberNo;
                        }
                    }
                }
            }
        }


        const form = document.postForm;
        form.no.value = '';
        form.day.value = new Date(date.getTime() + (9   *   60   *   60   *   1000)).toISOString().split("T")[0]
        form.memberNo.value = memberNo;
        form.price.value = '';
        MicroModal.show("modal");        
    }

    const fn_update = (ob)=>{        
        const form = document.postForm;
        form.no.value = ob.no;
        form.day.value = ob.day;
        form.memberNo.value = ob.memberNo;
        form.price.value = ob.price;
        MicroModal.show("modal");        
    }

    const fn_deleteAction = async(ob)=>{
        const url = process.env.REACT_APP_API_URL + '/gsDeleteAction'
        const formData = new FormData();
        formData.append('no', ob.no);
        const config = {method : 'post', body : formData}
        const msg = '삭제하시겠습니까?';

        await Swal.fire({
            title: msg
            , showCancelButton: true
            , confirmButtonText: "확인"
            , cancelButtonText: `취소`
        }).then(async (result) => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: "처리중입니다.",
                    html: "잠시만 기다려주시기 바랍니다.",
                    allowOutsideClick: false,
                    didOpen: () => {
                        Swal.showLoading();
                    },
                });
                
                const data = await api_commonFetch(url, config);
                
                if(data.result>0){
                    await Swal.fire("정상적으로 처리되었습니다.");
                    fn_getGsList();
                }else{
                    await Swal.fire("처리중 오류가 발생하였습니다.");
                }
            }
        });
    }
    

    useEffect(()=>{
        fn_getGsList();
    }, [vo]);
    
    
    return (
        <>
            <form name='searchForm' onSubmit={(e)=>{fn_search();}} className="search-form">
                <div className="col-6">
                    <input type='date' name="searchStartDate" defaultValue={vo.searchStartDate} onChange={(e)=>{fn_search();}}/>
                </div>
                <div className="col-6">
                    <input type='date' name="searchEndDate" defaultValue={vo.searchEndDate} onChange={(e)=>{fn_search();}}/>
                </div>
            </form>

            <div className="text-right">
                <button className="btn btn-primary" onClick={(e)=>{
                    e.preventDefault();
                    fn_insert();
                }}>신규등록</button>
            </div>
            <table className="table list">  
                <thead>
                    <tr>
                        <th>날짜</th>
                        <th>멤버</th>
                        <th>금액</th>
                        <th>수정/삭제</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        loading == true ? (
                            <tr>
                                <td colSapn={99}>
                                    로딩중..
                                </td>
                            </tr>
                        ) : (
                            <>
                                {
                                    gsList!=null && gsList.length>0 ? (
                                        gsList.map((ob, i)=>{
                                            return (
                                                <tr key={ob.no}>
                                                    <td>
                                                        {ob.day} ({fn_getDayOfWeek(ob.day)})
                                                    </td>
                                                    <td>
                                                        {ob.memberName}
                                                    </td>
                                                    <td>
                                                        {Number(ob.price).toLocaleString()} 원
                                                    </td>
                                                    <td>
                                                        <button className="btn btn-success" onClick={(e)=>{
                                                            e.preventDefault();
                                                            fn_update(ob);
                                                        }}>수정</button>
                                                        <button className="btn btn-danger" onClick={(e)=>{
                                                            e.preventDefault();
                                                            fn_deleteAction(ob);
                                                        }}>
                                                            삭제
                                                        </button>
                                                    </td>
                                                </tr>
                                            );
                                        })
                                    ) : ''
                                }
                            </>
                        )
                    }
                    
                </tbody>
            </table>

            <Modal id="modal">
                <form name="postForm" onSubmit={(e)=>{fn_postForm(); e.preventDefault();}}>
                    <input type="hidden" name='no'/>
                    <table className="table">
                        <colgroup>
                            <col style={{width:'25%'}}/>
                            <col style={{width:'75%'}}/>
                        </colgroup>
                        <tbody>
                            <tr>
                                <th>날짜</th>
                                <td className="text-left">
                                    <input type="date" name="day"/>
                                </td>
                            </tr>
                            <tr>
                                <th>멤버</th>
                                <td className="text-left">
                                    <select name="memberNo">
                                        {
                                            gsMemberList!=null && gsMemberList.length>0 ? (
                                                gsMemberList.map((ob, i)=>{
                                                    return (
                                                        <option value={ob.memberNo} key={ob.memberNo}>{ob.memberName}</option>
                                                    );
                                                })
                                            ) : ''
                                        }
                                    </select>
                                </td>
                            </tr>
                            <tr>
                                <th>가격</th>
                                <td className="text-left">
                                    <input type="number" name="price"/>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <div className="text-center">
                        <button className="btn btn-primary" onClick={(e)=>{
                            fn_postForm();
                        }}>저장</button>
                        <button className="btn btn-list" onClick={(e)=>{
                            e.preventDefault();
                            MicroModal.close("modal");
                        }}>닫기</button>
                    </div>
                </form>
            </Modal>
        </>
    );
}